import { render, staticRenderFns } from "./Lottie.vue?vue&type=template&id=391aed13&scoped=true"
import script from "./Lottie.vue?vue&type=script&lang=js"
export * from "./Lottie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391aed13",
  null
  
)

export default component.exports